import ServicesBanner from "./ServicesBanner";
import ServicesImage from "./ServicesImage";
import ServicesList from "./ServicesList";
import ServicesQuote from "./ServicesQuote";
import ServicesText from "./ServicesText";

export default function Services() {
  return (
    <>
    <ServicesBanner/> 
    <ServicesQuote/>
    <ServicesList/>
    <ServicesText/>
    <ServicesImage/>
    </>
  )
}
